/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'factory-int': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 32',
    data: '<path pid="0" d="M4 18v2h4v-2H4m0-4v2h10v-2H4m6 4v2h4v-2h-4m6-4v2h4v-2h-4m0 4v2h4v-2h-4M2 22V8l5 4V8l5 4V8l5 4 1-10h3l1 10v10H2z"/><text x="50%" y="32" text-anchor="middle">INT</text>'
  }
})
